import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

type AnalyticTokenProps = {
  startDate?: string | null;
  endDate?: string | null;
  billingAccountId?: string;
};
export const useAnalyticToken = ({ billingAccountId, startDate, endDate }: AnalyticTokenProps) => {
  const query = new URLSearchParams();

  if (billingAccountId) query.append('billingAccountId', billingAccountId);
  if (endDate) query.append('endDate', endDate);
  if (startDate) query.append('startDate', startDate);

  return useQuery({
    queryKey: ['billing-accounts/token-consumption-detail', billingAccountId, startDate, endDate],
    queryFn: async () => {
      const response: iResponse<{ message: string; data?: TokenCounts }> = await fetchAPI({
        method: 'GET',
        route: `billing-accounts/token-consumption-detail`,
        queryString: query.toString()
      });

      return response;
    },
    enabled: !!endDate && !!startDate,
    // Aggregates over the chosen range — minutes-old freshness is fine.
    staleTime: 10 * 60 * 1000
  });
};

export default useAnalyticToken;
